import Auth from '../../utils/Auth'

module.exports = {
  path: 'admin',
  onEnter: Auth.redirectAdminToLogin,
  indexRoute: {
    onEnter: (nextState, replace) => (Auth.userId() === 1 ? replace('/admin/users/list') : replace('/admin/glasses-list'))
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], require => {
      cb(null, [
        require('./routes/dashboard'),
        require('./routes/users'),
        ...require('./routes/summary-list'),
        ...require('./routes/glasses-list'),
        ...require('./routes/glasses-detail'),
        ...require('./routes/demo-list'),
        ...require('../app/routes/try-on-builder')
      ])
    })
  },
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require('./components/MainApp'))
    })
  }
}



// WEBPACK FOOTER //
// ./routes/admin/index.js